"use client";
import { NavLi } from "app/(headerwa)/(withfooter)/dashboard/layout.client";
import styles from "app/(headerwa)/(withfooter)/dashboard/layout.module.css";
import {
  pages,
  vendorpages,
} from "app/(headerwa)/(withfooter)/dashboard/pages";
import axios from "axios";
import useUser from "hooks/useUser";
import Link from "next/link";
import React from "react";
import { FiShoppingCart } from "react-icons/fi";

function DashbordList() {
  const { mutate, data } = useUser();
  return (
    <div className={styles.nav}>
      <nav>
        <ul className={styles.list}>
          {pages.map((page) => (
            <NavLi to={page.link} key={page.title}>
              <Link href={page.link as any} prefetch={false}>
                {page.icon}
                {page.title} {"extra" in page && page.extra}
              </Link>
            </NavLi>
          ))}
          {data?.role === "vendor" ? (
            <NavLi to="/vendor/dashboard" key="vendor">
              <Link href="/vendor/dashboard" prefetch={false}>
                <FiShoppingCart />
                Switch to Vendor Dashboard
              </Link>
            </NavLi>
          ) : (
            <NavLi to="/become-a-seller" key="vendor">
              <Link href="/become-a-seller" prefetch={false}>
                <FiShoppingCart />
                Become a Vendor
              </Link>
            </NavLi>
          )}
        </ul>
      </nav>
      <div>
        <button
          onClick={() => {
            axios.defaults.headers.common.Authorization = undefined;
            localStorage.removeItem("imprt");
            localStorage.removeItem("uat");
            mutate(undefined);
            location.reload();
          }}
        >
          Log out
        </button>
      </div>
    </div>
  );
}

export function AdminList() {
  const { mutate } = useUser();
  return (
    <div className={styles.nav}>
      <nav>
        <ul className={styles.list}>
          {vendorpages.map((page) => (
            <NavLi to={page.link} key={page.title}>
              <Link href={page.link as any} prefetch={false}>
                {page.icon}
                {page.title} {"extra" in page && page.extra}
              </Link>
            </NavLi>
          ))}
        </ul>
      </nav>
      <div>
        <button
          onClick={() => {
            axios.defaults.headers.common.Authorization = undefined;
            localStorage.removeItem("imprt");
            localStorage.removeItem("uat");
            mutate(undefined);
            location.reload();
          }}
        >
          Log out
        </button>
      </div>
    </div>
  );
}

export default DashbordList;
